import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AgreementBalance, _CreditRoleGroup, _DocumentAffiliate } from "../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../editor/AccountEditor";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { AccountEditorWhitRender } from "../../editor/AccountEditorWhitRender";






export const CreditRoleGroup = () => {

    const CreditRoleGroup = useDataBean(_CreditRoleGroup);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [])


    const getLista = () => {

        CreditRoleGroup.instance.getCreditRoleGroupCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        CreditRoleGroup.setBean({
            State: 1,

            IDEmployee: single.getAccountID()
            // Since: single.getCurrenDate()
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        CreditRoleGroup.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        CreditRoleGroup.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDCreditRoleGroup', visible: true },
        { title: 'Nombre Funcionario', property: 'AccountName', visible: true },
        { title: 'Rol', property: 'RoleName', visible: true },
        { title: 'Analista', property: 'IsAnalist', visible: true },
        { title: 'Referenciador', property: 'IsReference', visible: true },
        { title: 'Coordinador', property: 'IsCoordinate', visible: true },
        // { title: 'Usuario', property: 'IDEmployee', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Funcionarios Credito">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={CreditRoleGroup.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">

                                <div className="col-md-6">
                                    <AccountEditorWhitRender label="Funcionario" render={CreditRoleGroup.bean.AccountName} idAccount={CreditRoleGroup.bean.IDAccount} onChange={(e) => { CreditRoleGroup.setBean({ ...CreditRoleGroup.bean, "IDAccount": e.IDAccount, "AccountName": e.EntityName }) }}></AccountEditorWhitRender>
                                </div>
                                <div className="col-md-6">
                                    <label>Nombre Funcionario</label>
                                    <input name="AccountName" className="form-control" value={CreditRoleGroup.bean.AccountName} onChange={CreditRoleGroup.handleChange} readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Rol</label>
                                    <select className="form-control" value={CreditRoleGroup.bean.RoleName} onChange={(e) => { CreditRoleGroup.setBean({ ...CreditRoleGroup.bean, 'RoleName': e.target.value }) }}>
                                        <option value={0}>...</option>
                                        <option value='COORDINADOR'>COORDINADOR</option>
                                        <option value='ANALISTA'>ANALISTA</option>
                                        <option value='REFERENCIADOR'>REFERENCIADOR</option>


                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Analista" estado={CreditRoleGroup.bean.IsAnalist} eventChange={(e) => { CreditRoleGroup.setBean({ ...CreditRoleGroup.bean, "IsAnalist": e }) }}></BasicSwitch>
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Referenciador" estado={CreditRoleGroup.bean.IsReference} eventChange={(e) => { CreditRoleGroup.setBean({ ...CreditRoleGroup.bean, "IsReference": e }) }}></BasicSwitch>
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Coordinador" estado={CreditRoleGroup.bean.IsCoordinate} eventChange={(e) => { CreditRoleGroup.setBean({ ...CreditRoleGroup.bean, "IsCoordinate": e }) }}></BasicSwitch>
                                </div>

                            </div>

                        </>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}